<template>
    <Toast/>
    <ConfirmDialog :closeOnEscape="false" :closable="false" :draggable="false"></ConfirmDialog>
    <Sidebar
            class="black-sidebar"
             :visible="globalLoading || showModalLoading" :dismissable="false" :showCloseIcon="false" :modal="false" position="full">
        <ProgressSpinner class="spinner-center"/>
    </Sidebar>
	<div class="login-body">
		<div class="login-wrapper">
			<div class="login-panel">
				<img src="layout/images/logo-dark.svg" class="logo" alt="diamond-layout" />
                <form v-if="!li && !loginToken" @submit.prevent="handleSubmit(!v$.$invalid)" class="login-form p-fluid">
                    <h4 v-if="!sessionHasWarning">{{ customerName }}</h4>
                    <div v-else-if="sessionHasWarning" class="mb-3" style="max-width: 333px;"><InlineMessage :severity="sessionMessageSeverity">{{ sessionMessage }}</InlineMessage></div>
                    <div class="pages-detail mb-6 px-6">Usa la form per autenticarti a XLiteWeb</div>
                    <div class="field mb-3">
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon">
                                <i class="pi pi-user"></i>
                            </span>
                            <div class="p-float-label">
                                <InputText autocomplete="username" maxlength="100" type="text" id="username" v-model="v$.username.$model" :class="{'p-invalid':v$.username.$invalid && submitted}"/>
                                <label for="username" :class="{'p-error':v$.username.$invalid && submitted}">Username</label>
                            </div>
                        </div>
                        <small v-if="(v$.username.$invalid && submitted) || v$.username.$pending.$response" class="p-error">{{v$.username.required.$message.replace('Value', 'Username')}}</small>
                    </div>
                    <div class="field mt-3 mb-3">
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon">
                                <i class="pi pi-lock"></i>
                            </span>
                            <div class="p-float-label">
                                <Password id="password" :inputProps="{autocomplete: 'current-password'}" v-model="v$.password.$model" :class="{'p-invalid':v$.password.$invalid && submitted}" toggleMask :feedback="false" inputStyle="border-top-left-radius: 0;border-bottom-left-radius: 0;" />
                                <label for="password" :class="{'p-error':v$.password.$invalid && submitted}">Password</label>
                            </div>
                        </div>
                        <small v-if="(v$.password.$invalid && submitted) || v$.password.$pending.$response" class="p-error">{{v$.password.required.$message.replace('Value', 'Password')}}</small>
                    </div>
                    <Button type="submit" label="LOGIN" class="login-button mb-6 px-3" />
                    <Message v-show="loginErrorMessage" severity="error" :sticky="true">{{ loginErrorMessage }}</Message>
                </form>
                <div v-else-if="li=='temp'">
                    <h4 style="margin-bottom: 0;">Benvenuto {{ operatorWebLogin }}</h4>
                    <div style="display: grid;place-items: center;">
                        <div class="base-timer">
                            <svg class="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                <g class="base-timer__circle">
                                <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
                                <path
                                    id="base-timer-path-remaining"
                                    stroke-dasharray="283"
                                    :class="'base-timer__path-remaining '+remainingPathColor"
                                    d="
                                    M 50, 50
                                    m -45, 0
                                    a 45,45 0 1,0 90,0
                                    a 45,45 0 1,0 -90,0
                                    "
                                ></path>
                                </g>
                            </svg>
                            <span id="base-timer-label" class="base-timer__label">
                                {{ formattedTimeLeft }}
                            </span>
                        </div>
                    </div>
                    <div style="margin-bottom: 1rem;">
                        <Button type="button" icon="pi pi-hourglass" iconPos="right" class="p-button-text p-button-sm" @click="resetTimer()" label="Più tempo"></Button>
                        <Button type="button" icon="pi pi-sign-out" iconPos="right" class="p-button-text p-button-sm" @click="logout()" label="Non sei tu?"></Button>
                    </div>
                    <p>Sei attualmente attivo in {{ sessions.length }} {{ sessionlabel }}.</p>
                    <p>Chiudine una per usare xlite su questo dispositivo:</p>
                    <div>
                        <DataTable :value="sessions" :paginator="false" class="p-datatable-sessions p-datatable-sm"
                            dataKey="ref" :rowHover="true" responsiveLayout="stack" breakpoint="576px">
                            <template #empty>
                                Nessuna sessione.
                            </template>
                            <template #loading>
                                Caricamento in corso...
                            </template>
                            <Column field="ua" header="Dispositivo" headerStyle="width: 14rem;">
                                <template #body="{data}">
                                    {{formatDevice(data.ua)}}
                                </template>
                            </Column>
                            <Column field="cr" header="Creazione" headerStyle="width: 10rem;" dataType="date">
                                <template #body="{data}">
                                    {{formatDate(data.cr)}}
                                </template>
                            </Column>
                            <Column field="lu" header="Ultimo utilizzo" headerStyle="width: 10rem;" dataType="date">
                                <template #body="{data}">
                                    {{formatDate(data.lu)}}
                                </template>
                            </Column>
                            <Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible">
                                <template #body="{data}">
                                    <Button title="Termina sessione" :disabled="timeIsUp" type="button" icon="pi pi-trash" class="p-button-danger" @click="confirmTerminateSession(data.ref)"></Button>
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </div>
				<p>Problemi di login? <a href="https://www.slware.it?rrcd=xliteweblogin#contacts" target="_blank">Contattaci</a><br><Versions /></p>
			</div>
			<div class="login-image">
				<div class="login-image-content">
					<h1>Accedi a</h1>
					<h1>XLiteWeb</h1>
					<h3 style="max-width:380px">
						Nello username usa il <b>codice operatore</b> 
						o la <b>web-login</b>, da richiedere 
						al responsabile del punto vendita.
					</h3>
				</div>
				<div class="image-footer">
					<p><a href="https://www.slware.it/" target="_blank">slware.it</a> - Coded with soul</p>
					<!--<div class="icons">
						<a href="https://linkedin.com/company/slware" target="_blank"><i class="pi pi-linkedin"></i></a>
					</div>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { useRouter } from 'vue-router'
import { reactive, ref, computed, onMounted, onBeforeUnmount} from 'vue'
import { required, helpers } from "@vuelidate/validators"
import { useVuelidate } from "@vuelidate/core"
import { useConfirm } from "primevue/useconfirm"
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast"
import formatDevice from '@/utilities/UserAgentFormat.js'
import versions from '@/utilities/Version.js'
import Versions from '@/components/Versions.vue'
import XLiteService from '@/services/XLiteService.js'
const debug = require('debug')('xlite-web-client:login')

export default {
    components: {
        Versions
    },
    setup(){
        onMounted(() => {
            setTimeout(() => {
                const dashlane = document.body.querySelectorAll("span[data-dashlanecreated='true']")
                if(dashlane && dashlane.length > 1){
                    dashlane[1].setAttribute('style', 'visibility: hidden')
                }
            }, 500);
        })
        onBeforeUnmount(() => {
            debug('Login is about to unmount')
            clearInterval(timerInterval);
        })
        const timeIsUp = ref(false)
        const store = useStore()
        const router = useRouter()
        const confirm = useConfirm()
        const globalLoading = computed(() => store.getters.globalLoading)
        const showModalLoading = ref(false)
        const toast = useToast()
        //const toastLife = 3500
        const toastLifeWarn = 5500
        const toastLifeError = 7500

        const loginErrorMessage = ref()
        const sessions = ref([])
        const sessionlabel = computed(() => {
            return (!sessions.value.length || sessions.value.length > 1) ? 'sessioni' : 'sessione'
        })
        let errorMessageTimeout
        const state = reactive({
            username: '',
            password: ''
        })
        const messageLife = 6000
        //debug(route.params)

        const { customerName } = versions()
        const li = computed(() => store.getters.li)
        const operatorWebLogin = ref()
        // const for store getters are NOT using computed on purpose!
        const sessionTimeout = ref(store.getters.sto)
        const sessionTerminated = ref(store.getters.stt)
        const operatorDisabled = ref(store.getters.opd)
        // We don't need to memorize the states once we showed the message, resetting
        store.dispatch('setSto', false) // since getters are not using computed, the message will stay until reload
        store.dispatch('setStt', false)
        store.dispatch('setOpd', false)
        const networkIssue = ref(false)
        const licenseIssue = ref(false)
        const sessionHasWarning = computed(() => { return sessionTimeout.value || sessionTerminated.value || operatorDisabled.value })
        const sessionTimeoutMessage = 'La tua sessione è scaduta'
        const sessionTerminatedMessage = `Sessione terminata per login su ${sessionTerminated.value}`
        const operatorDisabledMessage = 'Impossibile rinnovare la sessione'
        const loginToken = ref((store.getters.requestedRouterDestination && store.getters.requestedRouterDestination.query.lt) ? store.getters.requestedRouterDestination.query.lt : null)
        const sessionMessage = computed(() => { 
            if(sessionTerminated.value){
                return sessionTerminatedMessage
            } else if (sessionTimeout.value){
                return sessionTimeoutMessage
            } else if(operatorDisabled.value) {
                return operatorDisabledMessage
            } else {
                return ''
            }
        })
        const sessionMessageSeverity = computed(() => { 
            if(sessionTerminated.value){
                return 'info'
            } else if (sessionTimeout.value){
                return 'warn'
            } else {
                return 'error'
            }
        })
        const submitted = ref(false)
        const validations = {
            username: {
                required: helpers.withMessage('Inserire codice operatore o web-login', required)
            },
            password: {
                required: helpers.withMessage('Inserire la password', required)
            }
        }        
        const v$ = useVuelidate(validations, state)

        // Initially, no time has passed, but this will count up
        // and subtract from the timeLimit
        const FULL_DASH_ARRAY = 283;
        const WARNING_THRESHOLD = 20;
        const ALERT_THRESHOLD = 10;
        const COLOR_CODES = {
            info: {
                color: "green"
            },
            warning: {
                color: "orange",
                threshold: WARNING_THRESHOLD
            },
            alert: {
                color: "red",
                threshold: ALERT_THRESHOLD
            }
        };
        const timeLimit = ref(0)
        const timePassed = ref(0)
        const timeLeft = computed(() => timeLimit.value - timePassed.value -5)
        const remainingPathColor = ref(COLOR_CODES.info.color)
        const formattedTimeLeft = computed(() => formatTime(timeLeft.value))
        let timerInterval = null

        const formatDate = (value) => {
            const dateValue = new Date(value)
            const date = dateValue.toLocaleDateString("it-IT", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
            const time = dateValue.toLocaleTimeString('it-IT')
            return `${date} @${time}`
        };

        const confirmTerminateSession = (sessionRef) => {
            confirm.require({
                //message: `Il dispositivo collegato alla sessione sarà disconnesso ed effettuerai l'accesso con questo dispositivo.`,
                message: `Il dispositivo indicato sarà disconnesso a favore di quello corrente.`,
                header: `Terminare la sessione selezionata?`,
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sì',
                acceptIcon: 'pi pi-trash',
                acceptClass: 'p-button-danger',
                rejectLabel: 'No',
                accept: () => {
                    terminateSession(sessionRef)
                }
            }) 
        }

        const terminateSession = (sessionRef) => {
            XLiteService.terminateSession(sessionRef)
                .then(() => {
                    handleLi()
                })
                .catch((err) => {
                    const errorCode = err.response.status || 400
                    const message = err.response.data || ''
                    debug(errorCode, message)
                    if(errorCode == 403){
                        toast.add({severity:'warn', summary: `Impossibile terminare la sessione selezionata`, detail: 'Link scaduto, riprova ora', life: toastLifeWarn})
                    } else if (errorCode == 404){
                        toast.add({severity:'warn', summary: `Impossibile terminare la sessione selezionata`, detail: 'La lista delle sessioni è stata aggiornata, riprova ora', life: toastLifeWarn})
                    }
                    handleLi()
                })
        }

        const handleSubmit = (isFormValid, loginToken = null) => {
            submitted.value = true
            if (!isFormValid) {
                return
            }

            clearTimeout(errorMessageTimeout)
            loginErrorMessage.value = ''
            sessionTimeout.value = false
            sessionTerminated.value = false
            operatorDisabled.value = false
            showModalLoading.value = true
            XLiteService.authenticate(state.username, state.password, loginToken)
                .then(response => {
                    handleLi(response.data, false)
                })
                .catch(err => {
                    resetForm()
                    if (err.response) {
                        // Request made and server responded
                        const data = err.response.data
                        const status = err.response.status
                        if(status == 400 && data == 'Invalid username or password'){
                            loginErrorMessage.value = 'Username o password errati'
                        } else if (status == 500 && data == 'License expired'){
                            loginErrorMessage.value = 'Licenza scaduta'
                        } else {
                            loginErrorMessage.value = 'Errore'
                        }
                        //debug('data', err.response.data)
                        //debug('status', err.response.status)
                        //debug('headers', err.response.headers)
                    } else if (err.request) {
                        // The request was made but no response was received
                        debug(err.request)
                        networkIssue.value = true
                        loginErrorMessage.value = 'Impossibile raggiungere il server'
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        debug(err.message)
                        loginErrorMessage.value = 'Errore'
                    }
                    
                    errorMessageTimeout = setTimeout(() => {
                        loginErrorMessage.value = ''
                    }, messageLife)
                    showModalLoading.value = false
                    //debug(`Error: `, err.message)
                })
                .finally(() => {
                    sessionTimeout.value = false
                    operatorDisabled.value = false
                    //store.dispatch('setDbPaths')
                })
        }

        const resetForm = () => {
            loginToken.value = null
            state.username = '';
            state.password = '';
            submitted.value = false;
        }

        const resetTimer = () => {
            clearInterval(timerInterval)
            handleLi()
        }

        const logout = async (isSessionTimeout = false) => {
            try {
                confirm.close()
                clearInterval(timerInterval)
                await store.dispatch('logout')
            } catch (err) {
                debug('Error logging out', err)
            } finally {
                if(isSessionTimeout){
                    sessionTimeout.value = true
                }
                resetForm()
                handleLi(null, true)
            }
        }

        const handleLi = async (res = null, manualLogout = false) => {
            let data = res ? res.data : null
            showModalLoading.value = true
            try {
                if(!data){
                    const response = await XLiteService.operatorInfo()
                    data = response.data
                    res = response
                }
                await store.dispatch('setLi', {li: data.li, e: res.headers['x-auth-e']})
                debug('li:', li.value)
                if(li.value === false && !manualLogout){
                    debug('Not logged in at all')
                    await store.dispatch('logout')
                    resetForm()
                    toast.add({severity:'error', summary: `La tua sessione è scaduta`, detail: 'Effettua nuovamente il login', life: toastLifeError})
                } else if(li.value === 'temp'){
                    operatorWebLogin.value = data.operatorData.operatorWebLogin
                    if(!data.sessions){
                        const response = await XLiteService.operatorSessions()
                        sessions.value = response.data.sessions
                    } else {
                        sessions.value = data.sessions
                    }
                    debug('sessions:', sessions.value)
                    
                    timeLimit.value = Math.floor((res.headers['x-auth-e']-((new Date()).getTime()))/1000)
                    startTimer()
                } else if(li.value === 'lasting'){
                    await store.dispatch('setOperator', data.operatorData)
                    store.commit('INITIALISE_OPERATOR_PREFERENCES')
                    const requestedRouterDestinationName = store.getters.requestedRouterDestination ? store.getters.requestedRouterDestination.name : null
                    const requestedRouterDestinationQuery = store.getters.requestedRouterDestination ? store.getters.requestedRouterDestination.query : null
                    if(requestedRouterDestinationQuery){
                        delete requestedRouterDestinationQuery.lt
                    }
                    if(requestedRouterDestinationName){
                        store.dispatch('setRequestedRouterDestination', null)
                        router.replace({ name: requestedRouterDestinationName, query: requestedRouterDestinationQuery })
                    } else {
                        router.replace({ name: 'dashboard' })
                    }
                }
                showModalLoading.value = false
            } catch (err){
                debug('error', err)
            }
        }
    
        const formatTime = (time) => {
            // The largest round integer less than or equal to the result of time divided being by 60.
            const minutes = Math.floor(time / 60);
            
            // Seconds are the remainder of the time divided by 60 (modulus operator)
            let seconds = time % 60;
            
            // If the value of seconds is less than 10, then display seconds with a leading zero
            if (seconds < 10) {
                seconds = `0${seconds}`;
            }

            // The output in MM:SS format
            return `${minutes > 0 ? minutes+'\'' : ''} ${seconds >= 0 ? seconds+'"' : ''}`;
        }

        const onTimesUp = async () => {
            logout(true)
        }
        
        const startTimer = () => {
            timePassed.value = 0
            timerInterval = setInterval(() => {
                // The amount of time passed increments by one
                timePassed.value++;
                setCircleDasharray();
                setRemainingPathColor(timeLeft.value)
                if (timeLeft.value === 0) {
                    onTimesUp();
                }

            }, 1000);
        }

        const calculateTimeFraction = computed(() => {
            const rawTimeFraction = timeLeft.value / timeLimit.value;
            return rawTimeFraction - (1 / timeLimit.value) * (1 - rawTimeFraction);
        })

        // Update the dasharray value as time passes, starting with 283
        const setCircleDasharray = () => {
            const circleDasharray = `${(
                calculateTimeFraction.value * FULL_DASH_ARRAY
            ).toFixed(0)} 283`;
            const baseTimerPathRemaining = document.getElementById("base-timer-path-remaining")
            if(baseTimerPathRemaining) baseTimerPathRemaining.setAttribute("stroke-dasharray", circleDasharray);
        }

        const setRemainingPathColor = (timeLeft) => {
            const { alert, warning, info } = COLOR_CODES;
            const baseTimerPathRemaining = document.getElementById("base-timer-path-remaining")
            if(baseTimerPathRemaining){
                if (timeLeft <= alert.threshold) {
                    baseTimerPathRemaining.classList.remove(info.color);
                    baseTimerPathRemaining.classList.remove(warning.color);
                    baseTimerPathRemaining.classList.add(alert.color);
                } else if (timeLeft <= warning.threshold) {
                    baseTimerPathRemaining.classList.remove(info.color);
                    baseTimerPathRemaining.classList.remove(alert.color);
                    baseTimerPathRemaining.classList.add(warning.color);
                } else {
                    baseTimerPathRemaining.classList.remove(warning.color);
                    baseTimerPathRemaining.classList.remove(alert.color);
                    baseTimerPathRemaining.classList.add(info.color);
                }
            }
        }

        if(li.value === 'temp'){
            handleLi()
        } else if(li.value !== 'lasting' && loginToken.value){
            handleSubmit(true, loginToken.value)
        } else if(li.value == 'lasting' && loginToken.value){
            alert('Gia autenticato!')
        }

        return {
            timeIsUp,
            state,
            v$,
            li,
            loginToken,
            operatorWebLogin,
            submitted,
            formattedTimeLeft,
            formatDate,
            formatDevice,
            handleSubmit,
            confirmTerminateSession,
            logout,
            resetTimer,
            remainingPathColor,
            globalLoading,
            showModalLoading,
            loginErrorMessage,
            messageLife,
            sessionTimeout,
            operatorDisabled,
            networkIssue,
            licenseIssue,
            sessionMessage,
            sessionMessageSeverity,
            sessionHasWarning,
            sessions,
            sessionlabel,
            customerName
        }
    }
}
</script>

<style>
.p-datatable-sessions .p-column-title{
    margin-right: 20px;
    min-width: 55%;
}
.p-confirm-dialog{
    max-width: 330px;
}
.p-confirm-dialog-message{
    text-align: justify;
}

/* Timer */
/* Sets the containers height and width */
.base-timer {
  position: relative;
  height: 45px;
  width: 45px;
}

/* Removes SVG styling that would hide the time label */
.base-timer__circle {
  fill: none;
  stroke: none;
}

/* The SVG path that displays the timer's progress */
.base-timer__path-elapsed {
  stroke-width: 7px;
  stroke: grey;
}

.base-timer__label {
  position: absolute;
  
  /* Size should match the parent container */
  width: 45px;
  height: 45px;
  
  /* Keep the label aligned to the top */
  top: 0;
  
  /* Create a flexible box that centers content vertically and horizontally */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Sort of an arbitrary number; adjust to your liking */
  font-size: 12px;
}

.base-timer__path-remaining {
  /* Just as thick as the original ring */
  stroke-width: 7px;

  /* Rounds the line endings to create a seamless circle */
  stroke-linecap: round;

  /* Makes sure the animation starts at the top of the circle */
  transform: rotate(90deg);
  transform-origin: center;

  /* One second aligns with the speed of the countdown timer */
  transition: 1s linear all;

  fill-rule: nonzero;

  /* Allows the ring to change color when the color value updates */
  stroke: currentColor;
}

.base-timer__path-remaining.green {
  color: rgb(65, 184, 131);
}

.base-timer__path-remaining.orange {
  color: orange;
}

.base-timer__path-remaining.red {
  color: red;
}

.base-timer__svg {
  /* Flips the svg and makes the animation to move left-to-right */
  transform: scaleX(-1);
}
</style>